<mat-toolbar>
    <mat-toolbar-row class="centered">
        <button mat-flat-button color = "primary" class = "rowButton"
        (click)="openNewProductDialog()">Add Product</button>
        <button mat-flat-button color = "accent" class = "rowButton"
        (click)="openNewInventoryDialog()">Add To Inventory</button>
    </mat-toolbar-row>
</mat-toolbar>